import type { Typographies } from "@superblocksteam/shared";
export const DEFAULT_TABS_WIDGET_HEADER_STYLE_VARIANT: keyof Typographies =
  "body2";
